import React from 'react'
import FieldProto from "../../../../../proto/field-proto"

type Props = {
    className?  : string
    field       : FieldProto
    options     : any
    onClick     : callback      // open dropdown
    children    : any
}

export default function FieldDatetime_FormValueEmpty(props:Props) {

    const showIcon = _.get(props.options, 'showIcon', true)

    return (
        <React.Fragment>
            <div className = {Classes("ui5-field-form-editable dropdown-form h-36", props.className)}
                 onClick   = {props.onClick}>
                {showIcon && <div className="ui5-ico-16 i5-deadline m-r-10"></div>}
                <div className="ui5-txt-no-accent-default txt-truncate">{props.field.placeholder}</div>
            </div>
            {props.children}
        </React.Fragment>
    )
}
